import unescape from 'lodash/unescape';

export interface BookingCustomerProps {
  client: {
    firstName: string;
    lastName: string;
    id: string;
    companyName: string;
  };
}

export default function BookingCustomer(props: BookingCustomerProps) {
  const { client } = props;
  return (
    <div>
      <strong>{unescape(client.companyName)}</strong>
      {client.companyName && <br />}
      <span>{unescape(`${client.firstName} ${client.lastName}`)}</span>
    </div>
  );
}
